import easyCheckApi, { easyCheckRequest } from '../api/config';

export const userService = {
  // Get users for current company
  getCompanyUsers: async (pageNumber = 1, pageSize = 10) => {
    return easyCheckRequest(() => 
      easyCheckApi.get(`/users/company?pageNumber=${pageNumber}&pageSize=${pageSize}`)
    );
  },

  // Add new user to company (enhanced signup for company users)
  addUserToCompany: async (userData) => {
    return easyCheckRequest(() => 
      easyCheckApi.post('/users/addtocompany', userData)
    );
  },

  // Update user role
  updateUserRole: async (userId, role) => {
    return easyCheckRequest(() =>
      easyCheckApi.put(`/users/${userId}/role`, { role })
    );
  },

  // Update per-user module permissions (null = full access)
  updateUserPermissions: async (userId, permissions) => {
    return easyCheckRequest(() =>
      easyCheckApi.put(`/users/${userId}/permissions`, { permissions })
    );
  },

  // Deactivate user
  deactivateUser: async (userId) => {
    return easyCheckRequest(() => 
      easyCheckApi.put(`/users/${userId}/deactivate`)
    );
  },

  // Reactivate user
  reactivateUser: async (userId) => {
    return easyCheckRequest(() => 
      easyCheckApi.put(`/users/${userId}/reactivate`)
    );
  },

  // Resend verification email
  resendVerificationEmail: async (userId) => {
    return easyCheckRequest(() => 
      easyCheckApi.post(`/users/${userId}/resend-verification`)
    );
  }
};

export const useUserService = () => {
  return userService;
}; 